export default "__VITE_PUBLIC_ASSET__4803e2c0__"